import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';
import { COMPONENT_MODE } from '../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../workflow-components.service';
  
export interface ElectronicSignatureModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
}
  
export class ElectronicSignatureModel extends DynamicInputModel {
	@serializable() readonly type: string = 'electronic_signature';
	componentMode: COMPONENT_MODE;
	constructor(config: ElectronicSignatureModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
	}

	static initModel(_component: Model_WorkflowComponent): ElectronicSignatureModel {
		const formModel = new ElectronicSignatureModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
            additional: _component,
			relations: _component.RELATIONS
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
		return {
			ID: 'electronic-signature',
			CODE: CODE_WORKFLOW_COMPONENT.ELECTRONIC_SIGNATURE,
			ICON: 'terminal-outline',
			LABEL: 'Signature Electronique',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
			]
		};
	}
}
  